export default "/images/cukraszda.png?644b9b08b3eabd3d71ebae4877d06e47";